import { useEffect, useRef, useState } from 'react';
import { useReward } from '@/contexts/reward-context';
import { CustomerPrizeInfo, RewardScene } from '@/types';
import SlotCounter from 'react-slot-counter';
import { addCommas } from '@/utils';
import { Button } from '../../../../ui/src/components/button'

export const JackPotNotice = () => {
	const buttonRef = useRef<HTMLButtonElement>(null);
	const { labels, onClose, getCustomerPrizeInfo, isPrizeInfoNoticed, onStatementSabaCoinOpen, fontClassName, onKafkaSet, platform, setRewardScene } = useReward();
	const [customerPrizeInfo, setCustomerPrizeInfo] = useState<CustomerPrizeInfo>();

	useEffect(() => {
		if (getCustomerPrizeInfo) {
			getCustomerPrizeInfo().then((res) => {
				setCustomerPrizeInfo(res);
			})
		}
	}, [])

	const gotoShop = () => {
		if (onKafkaSet) {
			onKafkaSet({
				note: '2024_EPL_Promotion',
				type: platform == 'Mars' ? 2 : 1,
				action: (window.innerWidth < 750 ? 14 : 28)
			})
		}
		if (isPrizeInfoNoticed) {
			isPrizeInfoNoticed().then(() => {
				if (setRewardScene) {
					setRewardScene(RewardScene.Shop);
				}
			})
		}
	}

	const onReceive = (event: string) => {
		if (buttonRef.current) {
			buttonRef.current.disabled = true;
		}

		if (onKafkaSet) {
			onKafkaSet({
				note: '2024_EPL_Promotion',
				type: platform == 'Mars' ? 2 : 1,
				action: (window.innerWidth < 750 ? 13 : 27)
			})
		}
		if (isPrizeInfoNoticed) {
			isPrizeInfoNoticed().then(() => {
				if (event == 'check' && onStatementSabaCoinOpen) {
					onStatementSabaCoinOpen();
					onClose();
				}
			})
		}
	}

	return (
		<div className="jackpot-popup">
			<img src="/images/promotion/epl/popup-banner.png" alt="" width={350} height={140} />
			<div className="jackpot-popup__wrap">
				<div className="jackpot-popup__container">
					<div className="jackpot-popup__title">
						{(labels?.lbl_ECPWinNotice ?? '').replace('{x}', (customerPrizeInfo?.MatchCount ?? 0).toString())}
					</div>
					<div className="jackpot-match-card__main">
						<div className="jackpot-prize">
							<div className="jackpot-popup__currency">SBC</div>
							<SlotCounter
								numberClassName={fontClassName}
								containerClassName="jackpot-prize__money"
								value={addCommas((customerPrizeInfo?.TotalPrize ?? 0).toString())}
								charClassName="jackpot-prize__char"
							/>
						</div>
					</div>
					<div className="jackpot-popup__bottons">
						<Button
							variant={'classic'}
							className="jackpot-popup__secondary-btn"
							onClick={() => onReceive('check')}
						>
							{labels?.lbl_CheckStatement}
						</Button>
						{
							(
								<Button
									variant={'classic'}
									className="jackpot-popup__primary-btn"
									onClick={gotoShop}
								>
									{labels?.lbl_EPLRedeem}
								</Button>
							)
						}
					</div>
				</div>
			</div>
		</div>
	);
};